import React from "react";
import styles from "./HomeNewsletter.module.scss";
import ManAndWoman from "./assets/man_woman.png";
import Circles from "./assets/circles.png";
const { newsletter, content, formside, svgside } = styles;
const Newsletter = () => {
  return (
    <section className={`${newsletter} global-lr-pad`}>
      <div className={content}>
        <div className={svgside}>
          <img
            src={ManAndWoman}
            alt="Man and Woman using the we quick pay app"
          />
        </div>

        <div className={formside}>
          <img src={Circles} alt="Circles" />
          <h4>Stay up to date</h4>
          <p>Your’e probably thinking, “Another newsletter?”</p>
          <p>But we promise, youre going to love ours!</p>
          <form>
            <input type="text" placeholder="Your Email Address"/>
            <button type="submit">Subscribe</button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
